module.exports = __webpack_public_path__ + "img/msu3-3.806b885e.png";